<template>
    <span v-if="explanation" class="tool-tip-container" v-on:mouseleave="toolTipMouseOut()">
        <v-icon v-on:mouseenter="toolTipMouseEnter()">tool-tip-icon fas fa-question-circle</v-icon>
        <div class="tool-tip-explanation">
            <div class="tool-tip-explanation-tail"></div>
            {{explanation}}
        </div>
    </span>
</template>

<script>
    export default {
        name: "tooltip",
        props: {
            explanation : ''
        },
        methods:{
            toolTipMouseEnter : function () {
                var explanation = this.$el.querySelector('.tool-tip-explanation'),
                    tailf = explanation.querySelector('.tool-tip-explanation-tail');

                explanation.style.top = Math.abs(parseInt(window.getComputedStyle(this.$el.querySelector('.tool-tip-icon'),null).getPropertyValue('top'))) * 2 + 3 + 'px';
                explanation.style.left = window.getComputedStyle(this.$el.querySelector('.tool-tip-icon'),null).getPropertyValue('left');

                // tailf.style.left = window.getComputedStyle(this.$el.querySelector('.tool-tip-icon'),null).getPropertyValue('left');
            },
            toolTipMouseOut : function () {
                var explanation = this.$el.querySelector('.tool-tip-explanation');

                explanation.style.top = '-99999px';
                explanation.style.left = '-99999px';
            }
        }
    }
</script>

<style scoped>
    .tool-tip-container {
        position: relative;
    }

    .tool-tip-icon {
        font-size: 16px;
        position: absolute;
        top: -9px;
        left: 10px;
    }

    .tool-tip-explanation {
        position: absolute;
        top: -99999px;
        left: -99999px;
        z-index: 100;
        font-size: 14px;
        background: rgba(0, 0, 0, 0.3);
        padding: 8px;
        text-align: justify;
        border: 2px solid black;
        max-width: 17rem;
    }

    .tool-tip-explanation-tail {
        position: absolute;
        top: -16px;
        left: 0;
        width: 0;
        height: 0;

        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 16px solid black;
    }
</style>